<div class="text-gray shadow-lg rounded-2 bg-dark border border-darkgray p-2 px-3 legend">
  <ng-Content></ng-Content>
</div>
